// src/forms/bankDetailsConfig.js

const BankConfig = [
  {
    name: 'account_number',
    label: 'Account Number',
    type: 'text',
    placeholder: 'Enter  Account Numnber',
    rules: { required: 'Account Number is required' },
  },
    {
      name: 'account_name',
      label: 'Account Name',
      type: 'text',
      placeholder: 'Enter account holder name',
      rules: { required: 'Account holder name is required' },
    },
    {
      name: 'account_type',
      label: 'Account Type',
      type: 'select',
      defaultValue: 'checking', 
      options: [
        { value: 'savings', label: 'Savings' },
        { value: 'checking', label: 'Checking' },
      ],
      rules: { required: 'Account type is required' },
    },
    {
      name: 'bank_name',
      label: 'Bank Name',
      type: 'text',
      placeholder: 'Enter  Bank name',
      rules: { required: 'Bank name is required' },
    },
    

    {
      name: 'branch_name',
      label: 'Bank Branch',
      type: 'text',
      placeholder: 'Enter  Bank Branch',
      rules: { required: 'Bank Branch is required' },
    },

    

    // {
    //   name: 'branch_code',
    //   label: 'Branch Code',
    //   type: 'text',
    //   placeholder: 'Enter  Bank name',
    //   rules: {},
    // },
    {
      
      name: 'swift_code',
      label: 'Swift Code',
      type: 'text',
      placeholder: 'Enter  Bank name',
      rules: {},
    },
  
    // {
    //   name: 'terms_accepted',
    //   label: 'Confirm data is correct',
    //   type: 'checkbox',
    //   defaultValue: false,
    //   rules: { required: 'You must confirm data is correct' },
    // },
  ];
  export default BankConfig;